module.exports = __webpack_public_path__ + "img/ent.b8de9144.png";